import { computed, atom, map, type MapStore, WritableAtom } from 'nanostores';
import { System, ConnectionTemplate } from '~/services/versori-api/types';

export class SystemStore {
  connectionTemplates: MapStore<Record<string, ConnectionTemplate>> = map({});
  runTimeSystems: WritableAtom<boolean> = atom<boolean>(false);
  currentSystemInManagement: WritableAtom<System | null> = atom<System | null>(null);
  currentConnectionTemplateInManagement: WritableAtom<ConnectionTemplate | null> = atom<ConnectionTemplate | null>(null);
  currentSystemManagementView: WritableAtom<'configure' | 'add' | 'connections' | 'none'> = atom<
    'configure' | 'add' | 'connections' | 'none'
  >('none');
  size = computed([this.connectionTemplates], (cts) => {
    return Object.keys(cts).length;
  });
  dynamicDataSystems: WritableAtom<boolean> = atom<boolean>(false);

  constructor() {
    this.connectionTemplates = map({});
    this.currentSystemInManagement = atom<System | null>(null);
    this.runTimeSystems = atom<boolean>(false);
    this.currentConnectionTemplateInManagement = atom<ConnectionTemplate | null>(null);
    this.currentSystemManagementView = atom<'configure' | 'add' | 'connections' | 'none'>('none');
    this.dynamicDataSystems = atom<boolean>(false);
  }

  setRunTimeSystems(value: boolean) {
    this.runTimeSystems.set(value);
  }

  setCurrentConnectionTemplateInManagement(connectionTemplate: ConnectionTemplate | null) {
    this.currentConnectionTemplateInManagement.set(connectionTemplate);
  }

  setCurrentSystemManagementView(view: 'configure' | 'add' | 'connections' | 'none') {
    this.currentSystemManagementView.set(view);
  }

  setDynamicDataSystems(value: boolean) {
    this.dynamicDataSystems.set(value);
  }

  setCurrentSystemInManagement(system: System | null) {
    this.currentSystemInManagement.set(system);
  }

  setConnectionTemplates(connectionTemplates: ConnectionTemplate[]) {
    this.connectionTemplates.set(
      connectionTemplates.reduce(
        (acc, ct) => {
          acc[ct.id] = ct;
          return acc;
        },
        {} as Record<string, ConnectionTemplate>
      )
    );
  }

  reset() {
    this.connectionTemplates.set({} as Record<string, ConnectionTemplate>);
    this.runTimeSystems.set(false);
    this.dynamicDataSystems.set(false);
    this.currentSystemInManagement.set(null);
  }
}
